module.exports = __webpack_public_path__ + "static/img/cont45 (3).87b88c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont45 (3).jpg
// module id = 0Oly
// module chunks = 0